'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'phone';
var width = 512;
var height = 512;
var aliases = [128222,128379];
var unicode = 'f095';
var svgPathData = 'M144.4 42.7c-3.4-8-12.2-12.3-20.6-10.1l-6.7 1.8C63.9 49 22.1 99.1 34.2 157.4 67.6 318 194.1 444.4 354.7 477.9 412.9 490 463.1 448.2 477.6 394.9l1.8-6.7c2.3-8.4-2-17.2-10.1-20.6l-93.3-38.9c-7.1-2.9-15.2-.9-20.1 5l-36.6 44.7c-4.7 5.7-12.6 7.5-19.2 4.3-75-35.6-135-97.6-168.1-174-2.8-6.6-1-14.2 4.6-18.7l41.6-34.1c5.9-4.8 8-13 5-20.1L144.4 42.7zm-29-40.9c23.9-6.5 49 5.7 58.5 28.6l38.9 93.3c8.4 20.1 2.6 43.4-14.3 57.2l-32.1 26.3c29 60.5 77.1 110.2 136.3 141.3l28.5-34.9c13.8-16.9 37-22.7 57.2-14.3l93.3 38.9c22.9 9.5 35.1 34.6 28.6 58.5l-1.8 6.7C490.8 468.3 427.2 525.6 348.2 509.2 175.1 473.2 38.9 337 2.9 163.9-13.6 84.8 43.7 21.3 108.7 3.6l6.7-1.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPhone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;